/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const navCategoryAccordionStyle = {
  navCategoryAccordion: {
    padding: "1rem 0",
    gap: "1rem",
    display: "none",
  },
  open: {
    display: "flex",
  },
  link: (theme: Theme) => ({
    color: theme.palette.text.primary,
  }),
};
